import { Button, CircularProgress } from "@mui/material";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import "./CreateArticle.css";
import ReactQuill from "react-quill";
import "../../node_modules/react-quill/dist/quill.snow.css";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import Stack from "@mui/material/Stack";
import { Input } from "@material-ui/core";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ReactTags from "react-tag-autocomplete";
import Backdrop from '@mui/material/Backdrop';
import CAlertBox from '../CAlertBox/CAlertBox';
// import Alert from '@mui/material/Alert';

const CreateArticle = () => {
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tags, setTags] = useState([]);
  const [category, setcategory] = useState([])
  const [suggestion, setSuggestion] = useState([]);
  const [selected, setSelected] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openPreloader, setOpenPreloader] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  //error
  const [headerError, setHeaderError] = useState(false);
  const [bodyError, setBodyError] = useState(false);

  const changeTitle = (e) => {
    e.preventDefault();
    setHeader(e.target.value);
    if (e.target.value.trim() !== "") setHeaderError(false);
  };
  const changeDesc = (e) => {
    // e.preventDefault();
    setBody(e);
    if (e.trim() !== "") setBodyError(false);
  };

  useEffect(() => {
    let tagItem = [];

    let resData;

    axiosApiInstance
      .get("/tags")

      .then((req) => {
        resData = req.data.data;
        for (let i = 0; i < resData.length; i++) {
          let idItem = i;
          let data = resData[i];
          tagItem.push({ id: idItem, name: data });
        }

        setSuggestion(tagItem);
      });
  }, []);

  useEffect(() => {
    let Item = [];

    let resData;

    axiosApiInstance
      .get("/category")

      .then((req) => {
        resData = req.data.data;
        for (let i = 0; i < resData.length; i++) {
          let idItem = resData[i].id;
          let data = resData[i].name;
          Item.push({ id: idItem, name: data });
        }

        setCategories(Item);
      });
  }, []);



  const [files, setFiles] = useState([]);
  const [showName, setShowName] = useState([]);
  const [tagName, setTagName] = useState([]);
  const [categoryName, setCategoryName] = useState([]);

  // const MAX_LENGTH = 3;

  const onFileChange = (e) => {
    // if (showName.length + 1 > MAX_LENGTH) {
    //   e.preventDefault();
    //   alert(`Cannot upload files more than ${MAX_LENGTH}`);
    //   return false;
    // }

    const allAttach = Array.from(e.target.files).map((file) => file);

    const fileArray = Array.from(e.target.files).map((file) => file.name);
    const fileSize = Array.from(e.target.files).map((file) => file.size);

    const fileExtension = fileArray.toString().split(".").at(-1);
    const allowedFileTypes = [
      "jpg",
      "png",
      "zip",
      "txt",
      "doc",
      "docx",
      "jpg",
      "png",
      "jpeg",
      "xlsx",
      "xls",
    ];
    if (!allowedFileTypes?.includes(fileExtension)) {
      // window.alert(
      //   `File does not support. Files type must be ${allowedFileTypes.join(
      //     ", "
      //   )}`
      // );
      setAlertMessage(`File does not support. Files type must be ${allowedFileTypes.join(", ")}`);
      return false;
    }
    if (fileSize > 5163523) {
      // window.alert("Please upload a file smaller than 5 MB");
      setAlertMessage("Please upload a file smaller than 5 MB");
      return false;
    }

    setFiles((prevAtt) => prevAtt.concat(allAttach));
    setShowName((prevNames) => prevNames.concat(fileArray));
  };

  const remFile = (e) => {
    let x = e.target.getAttribute("delattach");
    setFiles(files.filter((v) => v.name !== x));
    setShowName(showName.filter((art) => art !== x));
  };


  const final = ReactHtmlParser(body);

  const reactTags = useRef();

  const onDelete = useCallback(
    (tagIndex) => {
      setTags(tags.filter((_, i) => i !== tagIndex));
    },
    [tags]
  );

  const onAddition = useCallback(
    (newTag) => {
      var names = tags.map(({ name }) => name);
      if (tags.length + 1 > 10) {
        // window.alert("Maximum 10 tags are allowed");
        setAlertMessage("Maximum 10 tags are allowed");
        return false;
      }
      if (!names.includes(newTag.name)) {
        setTags([...tags, newTag]);
      }
    },
    [tags]
  );

  let tagid;

  useEffect(() => {
    tagid = Array.isArray(tags) ? tags.map((x) => x.id) : [];
    setTagName(Array.isArray(tags) ? tags.map((x) => x.name) : []);
  }, [tags]);


  const onCategoryDelete = useCallback(
    (categoryIndex) => {
      setcategory(category.filter((_, i) => i !== categoryIndex));
    },
    [category]
  );

  const onCategoryAddition = useCallback(
    (newcategory) => {
      var names = category.map(({ name }) => name);

      if (!names.includes(newcategory.name)) {
        setcategory([...category, newcategory]);
      }
    },
    [category]
  );



  useEffect(() => {
    setCategoryName(Array.isArray(category) ? category.map((x) => x.name) : []);
  }, [category]);



  const navigate = useNavigate();

  let date = new Date().toLocaleString("default", {
    month: "long",
    year: "numeric",
    day: "numeric",
  });

  const fetchedToken = localStorage.getItem("token");

  const submitForm = (e) => {
    e.preventDefault();

    // Validate fields
    let isValid = true;

    if (header.trim() === "") {
      console.log('came')
      setHeaderError(true);
      isValid = false;
    }
    if (body.trim() === "") {
      setBodyError(true);
      isValid = false;
    }

    if (!isValid) return;

    setOpenPreloader(!openPreloader);
    setLoading(true);
    e.preventDefault();
    let bodyFormData = new FormData();
    bodyFormData.append("Title", header);
    bodyFormData.append("Description", body);
    // bodyFormData.append('file', imgFiles);
    for (let j = 0; j < files.length; j++) {
      let finalFiles = files[j];
      bodyFormData.append("file", finalFiles);
    }
    for (let i = 0; i < tags.length; i++) {
      let TagList = tagName[i];
      bodyFormData.append("Tags", TagList);
    }
    for (let i = 0; i < category.length; i++) {
      let CategoryList = categoryName[i];
      bodyFormData.append("Category", CategoryList);
    }

    axiosApiInstance.post("/article", bodyFormData).then((res) => {
      if (res.data.succeeded === true) {
        setOpenPreloader(openPreloader);
        navigate(-1);
        setLoading(false);
      }
    });
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
    clipboard: { matchVisual: false },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };
console.log('ca', headerError)
  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm}  />
      <SideBar />
      <div className="create-art">
      <div className="create-new-article">
      <Button
          className="back-btn"
          onClick={() => navigate(-1)}
          style={{
            backgroundColor: "#0A387D",
          }}
          variant="contained"
        >
          Back
        </Button>

        <p className="art-date-edit">{date}</p>
        <div className="edit-art-title">
          <p className="field">Header*:</p>
          <textarea
              type="text"
              onChange={changeTitle}
              value={header}
              placeholder="Enter article header"
            />
          {headerError && <p className="error-text">Header is required.</p>}
        </div>
        <div className="edit-art-desc">
          <p className="field">Body*:</p>
          <ReactQuill
            modules={modules}
            formats={formats}
            onChange={changeDesc}
            value={body}
            />
          {bodyError && <p className="error-text">Body is required.</p>}
        </div>
        <br />
        <p className="field">Tags:</p>
        <ReactTags
          // ref={reactTags}
          tags={tags}
          suggestions={suggestion}
          onDelete={onDelete}
          allowNew
          onAddition={onAddition}
          placeholderText={"Enter Tags"}
          limitTags={2}
          // noSuggestionsText ={"none"}
        />
        <br />

        <p className="field">Category:</p>
        <ReactTags
          ref={reactTags}
          tags={category}
          suggestions={categories}
          onDelete={onCategoryDelete}
          onAddition={onCategoryAddition}
          placeholderText={"Select"}
          noSuggestionsText={"No Options Available"}
        />

        <div className="attachment">
          <Stack direction="row" alignItems="center" spacing={2}>
            <label htmlFor="contained-button-file">
              <Input
                id="contained-button-file"
                style={{ display: "none" }}
                onChange={onFileChange}
                multiple
                type="file"
              />

              <Button
                className="addattach"
                // disabled={isDisable}
                variant="contained"
                component="span"
              >
                Drag Files Here
              </Button>
            </label>
          </Stack>
        </div>

        {showName?.length > 0
          ? showName?.map((shw, id) => (
              <div className="showFile" key={id}>
                {shw}
                <DeleteOutlineIcon
                  className="deleteFile"
                  delattach={shw}
                  onClick={remFile}
                />
              </div>
            ))
          : " "}
        {/* {showName.length > 0 ? (
          <div className="showFile">
            {showName}
            <DeleteOutlineIcon
              className="deleteFile"
              delattach={showName}
              onClick={remFile}
            />
          </div>
        ) : (
          " "
        )} */}

        <div className="create-art-controls">
          <Button
            className="art-save-btn"
            style={{
              backgroundColor: "#0A387D",
            }}
            variant="contained"
            onClick={submitForm}
          >
            {loading ? <CircularProgress style={{ color: "white" }} /> : "Save"}
          </Button>
          <Button
            className="cancel-btn-art"
            onClick={() => {
              navigate(-1);
            }}
            style={{
              backgroundColor: "#707070",
            }}
            variant="contained"
          >
            Cancel
          </Button>
        </div>
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openPreloader}
       
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      </div>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  );
};

export default CreateArticle;
